import { Validator } from '@vista-digital/validator';
import { formAssetsValidator } from '../../../subcomponents/form/form/types/assets';
import { formEventsValidator } from '../../../subcomponents/form/form/types/events';
import { defaultGiftCardCheckerConfig, giftCardCheckerConfigValidator } from './config';
import { defaultGiftCardCheckerDisplayText, giftCardCheckerDisplayTextValidator } from './display-text';
export const giftCardCheckerPropsValidator = Validator.object({
    assets: formAssetsValidator,
    config: giftCardCheckerConfigValidator,
    displayText: giftCardCheckerDisplayTextValidator,
    events: formEventsValidator
});
export const defaultGiftCardCheckerProps = {
    assets: {},
    config: defaultGiftCardCheckerConfig,
    displayText: defaultGiftCardCheckerDisplayText,
    events: {}
};
